import fetchApi from './fetchApi'

const baseUrl = `${process.env.REACT_APP_API_URL}/api/linkedInUsers`

class LinkedInService {
    loginWithLinkedIn = async (code: string) => {
        return fetchApi(`${baseUrl}`, {
            method: 'POST',
            body: JSON.stringify({ code }),
        })
    }
}

export default LinkedInService
